export default "__VITE_ASSET__DQ7p77D6__"